<template>
  <svg color="currentColor" viewBox="0 0 24 24">
    <title>battery-high-plus</title>
    <path fill="currentColor" d="M16 20H8V6H16M16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H16.67C17.41 22 18 21.41 18 20.67V5.33C18 4.6 17.4 4 16.67 4M15 16H9V19H15V16M15 7H9V10H15V7M15 11.5H9V14.5H15V11.5Z" />
    <circle cx="19" cy="20.8" r="4.5" fill="white" />
    <path fill="currentColor" d="M18 18V20H16V22H18V24H20V22H22V20H20V18H18Z" />
  </svg>
</template>

<script>
export default {
  name: "BatteryPlus",
}
</script>

<style scoped>

</style>
